import { html } from "lit-html";
import { ifDefined } from "lit/directives/if-defined.js";

import { CountrySwitchArgs } from "./sc-m-country-switch.types";

export const CountrySwitchTemplate = (args: CountrySwitchArgs) => {
  return html`
    <div class="sc-m-country-switch__content">
      <p class="sc-m-country-switch__description" aria-hidden="true">${args.description}</p>
      <div class="sc-m-country-switch__select-group">
        <sc-e-select
          class="sc-e-select sc-m-country-switch__select"
          name="ScCountrySwitchDropdown"
          label="${args.description}"
        >
          ${args.pages.map(
            (page, index) => html`
              <option class="sc-e-select__option" value="${page.url}" selected="${index === 0}">${page.title}</option>
            `,
          )}
        </sc-e-select>

        <a class="sc-e-button sc-e-button--negative sc-m-country-switch__cta" title="${ifDefined(args.ctaTitle)}">
          <span class="sc-e-button__label">${args.ctaLabel}</span>
        </a>
      </div>
      <button
        type="button"
        class="sc-e-button sc-e-button--tertiary sc-e-button--icon-only sc-m-country-switch__close"
        title="${ifDefined(args.closeTitle)}"
      >
        <span class="sc-h-screenreader-only">${args.closeLabel}</span>
        <sc-e-icon class="sc-e-icon sc-e-button__icon" icon-id="sc-icon-close"></sc-e-icon>
      </button>
    </div>
  `;
};
